import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

export default function MemberCheckin() {
  const { user } = useAuth();
  const [checking, setChecking] = useState(false);
  const [result, setResult]     = useState(null);

  const doCheckin = async () => {
    setChecking(true); setResult(null);
    try {
      const r = await axios.post('/member/checkin');
      setResult({ ok: true, msg: r.data.message });
    } catch (err) {
      setResult({ ok: false, msg: err.response?.data?.message || 'Check-in failed.' });
    } finally { setChecking(false); }
  };

  const qrValue = `fittofit:checkin:${user?.id}:${user?.email}`;

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Gym check-in</h1><p className="page-sub">Show this QR at the reception desk</p></div>
      </div>

      <div style={{ maxWidth:400, margin:'0 auto', display:'flex', flexDirection:'column', gap:18 }}>
        {/* QR Code */}
        <div className="card" style={{ padding:32, textAlign:'center' }}>
          <div style={{ background:'white', display:'inline-block', padding:18, borderRadius:12, marginBottom:18 }}>
            <QRCode value={qrValue} size={180} />
          </div>
          <div style={{ fontSize:15, fontWeight:600, marginBottom:4 }}>{user?.name}</div>
          <div style={{ fontSize:13, color:'var(--text-muted)' }}>Member ID #{user?.id}</div>
        </div>

        {/* Manual check-in */}
        <div className="card" style={{ padding:22 }}>
          <div style={{ fontSize:14, fontWeight:600, marginBottom:6 }}>Self check-in</div>
          <div style={{ fontSize:13, color:'var(--text-secondary)', marginBottom:16 }}>Tap the button below to record your visit if you don't have QR scanning at the desk.</div>

          {result && (
            <div style={{ background: result.ok ? 'var(--success-dim)' : 'var(--danger-dim)', border:`1px solid ${result.ok ? 'rgba(34,197,94,.3)' : 'rgba(239,68,68,.3)'}`, borderRadius:'var(--radius)', padding:'12px 16px', marginBottom:14, fontSize:13, color: result.ok ? 'var(--success)' : 'var(--danger)', fontWeight:500 }}>
              {result.ok ? '✅' : '❌'} {result.msg}
            </div>
          )}

          <button className="btn-primary" onClick={doCheckin} disabled={checking || result?.ok} style={{ width:'100%', justifyContent:'center', padding:'12px' }}>
            {checking ? 'Checking in…' : result?.ok ? 'Checked in today ✓' : '📲 Check in now'}
          </button>
        </div>
      </div>
    </div>
  );
}
